// Components
import Container from '../../Components/Container';
import Footer from '../../Components/Footer';

// Images
import aquinoLogin from '../../Images/wp-aquinas.jpg';
// Icons
import { HiOutlineUser } from 'react-icons/hi';
import { RiLockPasswordLine } from 'react-icons/ri';
import { IoChevronBackOutline } from 'react-icons/io5';
import './LoginWordpressPage.css';
import { useLoginWithWordpressPage } from './useLoginWithWordpressPage';

const LoginWordpressPage = () => {
	const {
		t,
		navigate,
		loginWordPress,
		setPassForm,
		setUsernameForm,
		passForm,
		usernameForm,
		usernameError,
		passwordError,
		loginError,
		loadingLogin,
	} = useLoginWithWordpressPage();

	return (
		<main className='loginPageWordpress'>
			<Container className='loginPageContainer'>
				<button className='backLoginButton' onClick={() => navigate('/')}>
					<IoChevronBackOutline />
					{t('Return')}
				</button>
				<section className='loginContainer'>
					<img src={aquinoLogin} alt='Aquino' />
					<p className='info'>
						{t('Welcome')} {t('Use your')} <b>{t('Wordpress')}</b>
						<br /> {t('username and password to')} {t('continue on')}{' '}
						<b>{t('Olib')}</b>.
					</p>

					<form
						className='formLogin'
						onSubmit={(e) => {
							e.preventDefault();
							loginWordPress(usernameForm, passForm);
						}}
					>
						<div className='formLogin__inputs'>
							{/* Username */}
							<div className='input-container'>
								<label>{t('Username or Email Address')}:</label>
								<input
									className={usernameError ? 'error-input' : ''}
									onChange={(e) => setUsernameForm(e.target.value)}
									type='text'
									placeholder={t('Username or Email Address')}
									required
								/>
								<HiOutlineUser />
								{usernameError && <p className='error-text'>{usernameError}</p>}
							</div>

							{/* Password */}
							<div className='input-container'>
								<label>{t('Password')}</label>
								<input
									className={passwordError ? 'error-input' : ''}
									onChange={(e) => setPassForm(e.target.value)}
									type='password'
									placeholder={t('Password')}
									required
								/>
								<RiLockPasswordLine />
								{passwordError && <p className='error-text'>{passwordError}</p>}
							</div>
						</div>

						<button className='btnLogin' type='submit' disabled={loadingLogin}>
							{loadingLogin ? (
								<>
									<span className='spinner'></span> {t('Logging in...')}
								</>
							) : (
								t('Login with Wordpress')
							)}
						</button>

						{loginError && (
							<p className='error-text login-error'>{loginError}</p>
						)}
					</form>
					<p className='descriptive'>
						{t('Enter your')} <b>{t('Wordpress')}</b>{' '}
						{t(
							'username and password in the fields to log in and access all features'
						)}
					</p>
				</section>
			</Container>
			<Footer allContent={false} />
		</main>
	);
};

export default LoginWordpressPage;
